// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DamageGaugeController from "./damage_gauge_controller"
application.register("damage-gauge", DamageGaugeController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExerciseTimerController from "./exercise_timer_controller"
application.register("exercise-timer", ExerciseTimerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistoryController from "./history_controller"
application.register("history", HistoryController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)
